export { Didomi, scriptType, isRegionEnabled, isEnvEnabled } from "./Didomi"
